export default __webpack_public_path__ + "static/media/Vegetarian.c4925170.png";